<template>
    <div class="infoBoxTop"  v-if="infoBoxType === 'carouselAll'">
        <v-container fluid >
            <v-carousel
                hide-delimiter-background
                delimiter-icon="mdi-circle-outline"
                class="carouselAll"
                height="auto">
                <template v-slot:prev="{ props }">
                    <v-btn
                        icon="mdi-chevron-left"
                        variant="plain"
                        @click="props.onClick"
                    ></v-btn>
                </template>
                <template v-slot:next="{ props }">
                    <v-btn
                        icon="mdi-chevron-right"
                        variant="plain"
                        @click="props.onClick"
                    ></v-btn>
                </template>
                {{ nextPeriodOvulationInDays() }}
                <v-carousel-item>
                    <p>
                        <span class="periodBG">Nächste Periode</span><br>
                        <span>{{ nextPeriodIn }}</span>
                    </p>
                </v-carousel-item>
                <v-carousel-item>
                    <p>
                        <span class="ovulationBG">Voraussichtlicher Eisprung</span><br>
                        <span>{{ nextOvulationdIn }}</span>
                    </p>
                </v-carousel-item>
                <v-carousel-item>
                    Letzte Periode dauerte<br>
                    {{ lastPeriodDayCount }}
                </v-carousel-item>
                <v-carousel-item>
                    durchschnittliche Zykluslänge<br>
                    {{ cycleLengthAVG }}
                </v-carousel-item>
                    <v-carousel-item>
                    letzte Zykluslänge<br>
                    {{ cycleLastLength }}
                </v-carousel-item>
            </v-carousel>
        </v-container>
    </div>
    <div v-else-if="infoBoxType === 'carouselPlusSep'">
        <div class="infoBoxTop" >
            <v-container fluid >
                <v-carousel
                    hide-delimiter-background
                    delimiter-icon="mdi-circle-outline"
                    class="carouselAll"
                    height="auto">
                    <template v-slot:prev="{ props }">
                        <v-btn
                            icon="mdi-chevron-left"
                            variant="plain"
                            @click="props.onClick"
                        ></v-btn>
                    </template>
                    <template v-slot:next="{ props }">
                        <v-btn
                            icon="mdi-chevron-right"
                            variant="plain"
                            @click="props.onClick"
                        ></v-btn>
                    </template>
                    {{ nextPeriodOvulationInDays() }}
                    <v-carousel-item>
                        <p>
                            <span class="periodBG">Nächste Periode</span><br>
                            <span>{{ nextPeriodIn }}</span>
                        </p>
                    </v-carousel-item>
                    <v-carousel-item>
                        <p>
                            <span class="ovulationBG">Voraussichtlicher Eisprung</span><br>
                            <span>{{ nextOvulationdIn }}</span>
                        </p>
                    </v-carousel-item>
                </v-carousel>
            </v-container>
        </div>
        <div class="infoBoxTop infoBoxMyCycles">
            <p>Meine Zyklen</p>
            <div>
                <h5>Länge des letzten Zyklus</h5>
                <span>{{ cycleLastLength }}</span>
            </div>
            <hr>
            <div>
                <h5>Länge der letzte Periode</h5>
                <span>{{ lastPeriodDayCount }}</span>
            </div>
            <hr>
            <div>
                <h5>Schwankungen der Zyklen</h5>
                <span>{{ cycleMinMax }}</span>
            </div>
        </div>
    </div>
    <div v-else-if="infoBoxType === 'C'">
    C
    </div>
</template>

<script>
    import {DataSummaries} from './../models/DataSummaries'
    import { ref, onMounted, onUnmounted, toRaw, toRef, isProxy } from 'vue'

    export default {
        name: 'InfoBoxes',
        props: {
            infoBoxType: String,
            PredictedSummary:Object
        },
        data (){
            return {
                nextPeriodIn: '',
                nextOvulationdIn: '',
                lastPeriodDayCount:'',
                cycleLengthAVG:'',
                cycleMinMax:'',
                cycleLastLength:'',
            }
        },
        
        methods: {
            nextPeriodOvulationInDays(){
                if(isProxy(this.PredictedSummary)){ 
                    let today = new Date();
                    let FallbackText = 'noch keine Daten verfügbar';
                    
                    //cycleLength
                    this.cycleLengthAVG = this.PredictedSummary.calculatedCycles.avgCycle+" Tage"
                    let minCycle = Math.min(...this.PredictedSummary.calculatedCycles.cycles)
                    let maxCycle = Math.max(...this.PredictedSummary.calculatedCycles.cycles)
                    if(this.PredictedSummary.calculatedCycles.avgCycle != 0){
                        if(minCycle == maxCycle){
                            if(minCycle != 'NaN')
                            this.cycleMinMax = minCycle+" Tage"
                        }else{
                            this.cycleMinMax = minCycle+"-"+maxCycle+" Tage"
                        }
                    }else{
                        this.cycleLengthAVG = FallbackText
                        this.cycleMinMax = FallbackText
                    }

                    let lastPeriodStartCy = Math.max(...this.PredictedSummary.firstDaysTS);
                    let HelpStartsCy = JSON.parse(JSON.stringify(this.PredictedSummary.firstDaysTS));
                    HelpStartsCy.splice(HelpStartsCy.indexOf(lastPeriodStartCy),1)
                    let secondLast = Math.max(...HelpStartsCy);
//
                    let DateLastPeriodStartCy = new Date()
                    DateLastPeriodStartCy.setTime(lastPeriodStartCy)
                    let ShiftedDateLastPeriodStartCy = new Date(DateLastPeriodStartCy.getFullYear(),DateLastPeriodStartCy.getMonth(),DateLastPeriodStartCy.getDate(),0,0,1)

                    let DateSecondLastPeriodEndCy = new Date()
                    DateSecondLastPeriodEndCy.setTime(secondLast)
                    let ShiftedDateSecondLastPeriodEndCy = new Date(DateSecondLastPeriodEndCy.getFullYear(),DateSecondLastPeriodEndCy.getMonth(),DateSecondLastPeriodEndCy.getDate(),23,59,59)
               
                    let lastCycleLength = ((ShiftedDateLastPeriodStartCy.getTime()-ShiftedDateSecondLastPeriodEndCy.getTime())/(24*60*60*1000))
                    if(!isNaN(lastCycleLength)){
                        this.cycleLastLength = (Math.ceil(lastCycleLength))+" Tage"
                    }else{
                        this.cycleLastLength = FallbackText
                    }

                    // Predicted PeriodData
                    let firstNextPeriodTS = Math.min(...this.PredictedSummary.predictedPeriodFirstDaysTS);
                    let daysToNextPeriod = (Math.ceil((firstNextPeriodTS-today.getTime())/(24*60*60*1000)));
                   
                    if(!isNaN(daysToNextPeriod)){
                        let PeriodTage = " Tage";
                        if((daysToNextPeriod < 2) && (daysToNextPeriod > -2))PeriodTage=" Tag";
                        let preTextPeriod = 'in ';
                        if(daysToNextPeriod < 0)preTextPeriod = 'verspätet um '
                        let textPeriod = preTextPeriod+Math.abs(daysToNextPeriod)+PeriodTage;
                        if((daysToNextPeriod < 0) && (daysToNextPeriod > -1))textPeriod="heute";
                        this.nextPeriodIn = textPeriod;
                    }else{
                        this.nextPeriodIn = FallbackText
                    }

                    // Predicted OvulationData
                    let daysToNextOvulation = ((this.PredictedSummary.predictedNextOvulationTS-today.getTime())/(24*60*60*1000));
                    if(this.PredictedSummary.predictedNextOvulationTS != 0){
                        //console.log((this.PredictedSummary.predictedNextOvulationTS-today.getTime())/(24*60*60*1000))
                        let OvulationTage = " Tagen";
                        if((daysToNextOvulation < 1) && (daysToNextOvulation > -1))OvulationTage=" Tag";
                        let preTextOvulation = 'in ';
                        let textOvulation = preTextOvulation+Math.abs(Math.ceil(daysToNextOvulation))+OvulationTage;
                        
                        if((Math.ceil(daysToNextOvulation) == this.cycleLengthAVG))textOvulation="heute";
                        this.nextOvulationdIn = textOvulation;
                    }else{
                        this.nextOvulationdIn = FallbackText
                    }

                    // Last Period
                    let lastPeriodStart = Math.max(...this.PredictedSummary.firstDaysTS);
                    let lastPeriodEnd = Math.max(...this.PredictedSummary.lastDaysTS);
                    if(((today.getTime()-lastPeriodStart)/(24*60*60*1000))<10){
                        let HelpStarts = JSON.parse(JSON.stringify(this.PredictedSummary.firstDaysTS));
                        HelpStarts.splice(HelpStarts.indexOf(lastPeriodStart),1)

                        let HelpEnds = JSON.parse(JSON.stringify(this.PredictedSummary.firstDaysTS));
                        HelpEnds.splice(HelpEnds.indexOf(lastPeriodEnd),1)

                        lastPeriodStart = Math.max(...HelpStarts);
                        lastPeriodEnd = Math.max(...HelpEnds);
                    }


                    let DateLastPeriodStart = new Date()
                    DateLastPeriodStart.setTime(lastPeriodStart)
                    let ShiftedDateLastPeriodStart = new Date(DateLastPeriodStart.getFullYear(),DateLastPeriodStart.getMonth(),DateLastPeriodStart.getDate(),0,0,1)
                    let DateLastPeriodEnd = new Date()
                    DateLastPeriodEnd.setTime(lastPeriodEnd)
                    let ShiftedDateLastPeriodEnd = new Date(DateLastPeriodEnd.getFullYear(),DateLastPeriodEnd.getMonth(),DateLastPeriodEnd.getDate(),23,59,59)
                    let lastPeriodDays = ((ShiftedDateLastPeriodEnd.getTime()-ShiftedDateLastPeriodStart.getTime())/(24*60*60*1000))
                    
                    if(!isNaN(lastPeriodDays)){
                        let LastPeriodTage = " Tage";
                        if(lastPeriodDays < 1)LastPeriodTage=" Tag";
                        this.lastPeriodDayCount = Math.ceil(lastPeriodDays)+LastPeriodTage
                    }else{
                        this.lastPeriodDayCount = FallbackText
                    }
                    
                }
            }
        },
        
        setup (props) {
            const infoBoxType = toRef(props, 'infoBoxType')
            let PredictedSummary =  toRef(props, 'PredictedSummary')
            if(typeof toRef(props, 'PredictedSummary').value == 'undefined'){
                PredictedSummary =  ref(null)
            }
            
            let nextPeriodIn = '';
            onMounted(
                async () => {
                    if(typeof toRef(props, 'PredictedSummary').value == 'undefined'){
                        PredictedSummary.value = await DataSummaries.getPeriodDays('withDayInfos');
                    }
                },
            )
            return {
                PredictedSummary,
                infoBoxType,
            }
        }
    }
</script>

<style>
    .carouselAll{
        text-align: center;
        height: 110px !important;
    }
    .carouselAll .v-responsive__content{
        display: inline-grid;
        align-items: center;
        padding-bottom: 50px;
        font-weight: bold;
    }

    .infoBoxTop{
      border: 1px solid black;
      border-radius: 10px;
    }
    .infoBoxTop .v-container{
      padding: 0;
    }
    
    .infoBoxTop .v-window__controls{
      padding: 0;
    }
    .infoBoxTop p > *{
        display: inline !important;
    }

    .infoBoxMyCycles{
        margin-top: 30px;
        padding: 15px;
    }
    .infoBoxMyCycles h5{
        color: darkgray;
    }
    .infoBoxMyCycles p{
        padding-bottom: 20px;
        font-weight: bold;
    }
    .infoBoxMyCycles span{
        font-weight: bold;
    }
    .infoBoxMyCycles hr{
        margin-top: 10px;
        margin-bottom: 10px;
    }
    .periodBG{
        background: #f7bebe;
    }
    .ovulationBG{
        background: #9cbff1;
    }
</style>